import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentRequestModuleType } from '@enums/document-request-module-type.enum';
import { DocumentRequest } from '@models/document-request';
import { DocumentRequestFile, DocumentRequestTemplate } from '@forms/document-request-template';
import { ErrorMessage } from '@interfaces/error-message';
import { FormHelper } from '@helpers/form.helper';

export type DocumentRequestFormType = {
  moduleType: FormControl<DocumentRequestModuleType>;
  title: FormControl<string>;
  description: FormControl<string>;
  accountingPeriodId: FormControl<number>;
  file: FormControl<DocumentRequestFile>;
};

export class DocumentRequestForm extends FormGroup<DocumentRequestFormType> {
  get moduleType(): FormControl<DocumentRequestModuleType> {
    return this.controls.moduleType;
  }

  get title(): FormControl<string> {
    return this.controls.title;
  }

  get description(): FormControl<string> {
    return this.controls.description;
  }

  get accountingPeriodId(): FormControl<number> {
    return this.controls.accountingPeriodId;
  }

  get file(): FormControl<DocumentRequestFile> {
    return this.controls.file;
  }

  get moduleTypeErrorMessage(): ErrorMessage {
    return FormHelper.getEmptyErrorMessage(this.controls.moduleType, 'Le type de demande est requis.');
  }

  get titleErrorMessage(): ErrorMessage {
    return FormHelper.getEmptyErrorMessage(this.controls.title, 'Le titre est requis.');
  }

  get descriptionErrorMessage(): ErrorMessage {
    return FormHelper.getEmptyErrorMessage(this.controls.description, 'Le message est requis.');
  }

  constructor() {
    super({
      moduleType: new FormControl<DocumentRequestModuleType>(null, Validators.required),
      title: new FormControl<string>(null, Validators.required),
      description: new FormControl<string>(null, Validators.required),
      accountingPeriodId: new FormControl<number>(null, Validators.required),
      file: new FormControl<DocumentRequestFile>(null)
    });
  }

  toDocumentRequest(): Pick<
    DocumentRequest,
    'moduleType' | 'title' | 'description' | 'accountingPeriodId' | 'fileUuid'
  > {
    return {
      moduleType: this.moduleType.value,
      title: this.title.value,
      description: this.description.value,
      accountingPeriodId: this.accountingPeriodId.value,
      fileUuid: this.file.value?.uuid
    };
  }

  enableInputs(): void {
    this.title.enable();
    this.description.enable();
    this.file.enable();
  }

  disableInputs(): void {
    this.title.disable();
    this.description.disable();
    this.file.disable();
  }

  setValuesFromTemplate(template: DocumentRequestTemplate | null): void {
    this.patchValue({
      title: template?.title ?? null,
      description: template?.description ?? null,
      file: template?.sampleFile ?? null
    });
  }
}
